import dayjs from 'dayjs'

export const isCourseNowFromDateString = (
  courseDate: string | number | null,
  duration?: number,
  now = dayjs()
) => {
  if (courseDate === null) return false

  const courseStart = dayjs(courseDate)
  if (!courseStart.isValid()) return false

  const courseDuration = duration ?? 60
  const startBuffer = duration === undefined ? 5 : 1
  const endBuffer = duration === undefined ? 5 : 2

  return (
    now.isAfter(courseStart.subtract(startBuffer, 'minute')) &&
    now.isBefore(courseStart.add(courseDuration, 'minute').add(endBuffer, 'minute'))
  )
}

export const displayFormattedMonth = (dayOfMonth: number) => {
  return dayOfMonth.toString().padStart(2, '0')
}

export const displayFormattedHour = (hour: number, minute = 0) => {
  return displayFormattedHourOriginal(hour, minute)
}

export const displayFormattedDate = (hour: number, minute = 0, fullDate: string | null) => {
  if (!fullDate) return ''
  const parisHour = displayFormattedHourOriginal(hour, minute)
  const monthName = dayjs(fullDate).locale('fr').format('MMMM')
  return dayjs(fullDate).format(`DD [${monthName}] YYYY à [${parisHour} (heure de Paris)]`)
}

export const displayFormattedHourOriginal = (hour: number, minute = 0) => {
  return `${hour.toString().padStart(2, '0')}h${minute.toString().padStart(2, '0')}`
}

export const getCoursePhase = (courseDate: string | null, currentTime = dayjs()) => {
  if (!courseDate) return null

  const courseStart = dayjs(courseDate)
  const courseEnd = courseStart.add(1, 'hour')
  const extendedEnd = courseEnd.add(1, 'minute')

  if (currentTime.isBefore(courseStart)) {
    return 'PRE_COURSE' // Sas d'entrée (1 min avant)
  } else if (currentTime.isBefore(courseEnd)) {
    return 'MAIN_COURSE' // Cours principal (60 min)
  } else if (currentTime.isBefore(extendedEnd)) {
    return 'POST_COURSE' // Sas de sortie (1 min après)
  } else {
    return 'ENDED' // Cours terminé
  }
}

export const getTimeUntilCourseEnd = (courseDate: string | null, currentTime = dayjs()) => {
  if (!courseDate) return null

  const courseEnd = dayjs(courseDate).add(1, 'hour')
  const diff = courseEnd.diff(currentTime, 'minute')

  return diff > 0 ? diff : 0
}
